import { useEffect, useRef } from "react";
import backgroundMusic from "../../assets/audio-test/background-instrumental-ko.mp3";
import countdownSound from "../../assets/audio-test/countdown-10-seconds.wav";
import jackpotImpact from "../../assets/audio-test/jackpot-impact-layer.wav";
import jackpotCoins from "../../assets/audio-test/jackpot-alarm-coins.wav";
import raceCrowd from "../../assets/audio-test/race-crowd-ambience.wav";

const AUDIO_DISABLED_KEY = "dogs8AudioTestDisabled";

const safePlay = (audio) => {
  if (!audio) return;
  const promise = audio.play();
  if (promise?.catch) promise.catch(() => {});
};

const stop = (audio, reset = false) => {
  if (!audio) return;
  audio.pause();
  if (reset) audio.currentTime = 0;
};

export const useDogs8AudioTest = ({ screen, paidJp, jackpotKey }) => {
  const audioRef = useRef();
  const previousScreen = useRef();
  const previousJackpotKey = useRef("");

  useEffect(() => {
    const disabledByQuery = new URLSearchParams(window.location.search).get("audioTest") === "off";
    if (disabledByQuery) localStorage.setItem(AUDIO_DISABLED_KEY, "true");
    if (new URLSearchParams(window.location.search).get("audioTest") === "on") localStorage.removeItem(AUDIO_DISABLED_KEY);

    const background = new Audio(backgroundMusic);
    const countdown = new Audio(countdownSound);
    const impact = new Audio(jackpotImpact);
    const coins = new Audio(jackpotCoins);
    const crowd = new Audio(raceCrowd);
    background.loop = true;
    crowd.loop = true;
    background.volume = 0.1;
    countdown.volume = 0.38;
    impact.volume = 0.34;
    coins.volume = 0.44;
    crowd.volume = 0.2;
    audioRef.current = { background, countdown, impact, coins, crowd };

    const unlock = () => {
      if (localStorage.getItem(AUDIO_DISABLED_KEY) === "true") return;
      if ([1, 3, 4].includes(Number(previousScreen.current))) safePlay(background);
    };
    window.addEventListener("pointerdown", unlock, { passive: true });

    return () => {
      window.removeEventListener("pointerdown", unlock);
      Object.values(audioRef.current || {}).forEach(audio => stop(audio, true));
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || localStorage.getItem(AUDIO_DISABLED_KEY) === "true") return;
    const nextScreen = Number(screen);
    const priorScreen = previousScreen.current;
    previousScreen.current = nextScreen;

    if ([1, 3, 4].includes(nextScreen) && !paidJp) safePlay(audio.background);
    else stop(audio.background);

    if (nextScreen === 2 && !paidJp) safePlay(audio.crowd);
    else stop(audio.crowd, true);

    if (nextScreen === 4 && priorScreen !== 4) {
      audio.countdown.currentTime = 0;
      safePlay(audio.countdown);
    }
    if (nextScreen !== 4) stop(audio.countdown, true);
  }, [screen, paidJp]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !paidJp || !jackpotKey || previousJackpotKey.current === jackpotKey || localStorage.getItem(AUDIO_DISABLED_KEY) === "true") return;
    previousJackpotKey.current = jackpotKey;
    stop(audio.background);
    stop(audio.crowd);
    audio.impact.currentTime = 0;
    audio.coins.currentTime = 0;
    safePlay(audio.impact);
    const coinsTimer = window.setTimeout(() => safePlay(audio.coins), 260);
    return () => window.clearTimeout(coinsTimer);
  }, [paidJp, jackpotKey]);
};
